<template>
<div class="chapter">
<div class="inner_page">
<div id="Epigraph.html" xml:lang="en-US">
<div class="Basic-Text-Frame-26">
<p class="ch"><a id="Anchor-1"></a><span class="bold-italic">     </span></p>
<p class="center"><span class="bold-italic">Many things grow in the garden that were
						never sown there<br/>—Thomas Fuller,</span>
<span class="bold">Gnomologia, 1732</span><br/><br/></p>
<p class="center"></p>
<p class="center"><span class="bold-italic">Worry gives a small thing a big
						shadow<br/></span><span class="bold">—Swedish proverb</span></p>
<p class="Basic-Paragraph-21"></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Epigraph.vue?336ea0ee